import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/modal';
import Card from 'components/card';

const InvoicePdfPreviewModal = (props: {
    isOpen: boolean;
    onClose: () => void;
    pdfUrl: string | null;
    fileName: string;
    onDownload: () => void;
}) => {
    const { isOpen, onClose, pdfUrl, fileName, onDownload } = props;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay className="bg-[#000] !opacity-50" />
            <ModalContent className="!z-[1002] !m-auto !w-max !max-w-[90%] top-[6vh]">
                <ModalBody>
                    <Card extra="flex !z-[1004] w-[90%] sm:w-[600px] rounded-xl border mx-auto">
                        <div className="mt-5 flex items-center justify-between px-5">
                            <h4 className="truncate text-lg font-medium">
                                {fileName || 'Prévisualisation'}
                            </h4>
                        </div>
                        <div className="ml-2 mt-2 justify-center px-8">
                            {pdfUrl ? (
                                <iframe
                                    title="invoice-pdf-preview"
                                    src={`${pdfUrl}#toolbar=0`}
                                    width="100%"
                                    height={600}
                                    className="rounded-xl border bg-white text-white"
                                />
                            ) : (
                                <div
                                    className="flex items-center justify-center rounded-xl border bg-white"
                                    style={{ height: 600 }}
                                >
                                    <p className="text-sm text-gray-400">
                                        Chargement de la prévisualisation...
                                    </p>
                                </div>
                            )}
                        </div>
                        <button
                            type="button"
                            onClick={onDownload}
                            disabled={!pdfUrl}
                            className="linear mx-auto my-5 flex items-center justify-center rounded-xl bg-toola-500 px-4 py-2 text-sm font-medium text-white transition duration-200 hover:bg-toola-600 active:bg-toola-700 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            Télécharger la facture
                        </button>
                    </Card>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default InvoicePdfPreviewModal;
